import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { RouteData } from '@fpr/core/models/route.models';
import { SessionManager } from '@fpr/core/services/session-manager.service';
import { ViewName } from '@fpr/core/models/session.models';

@Injectable({
    providedIn: 'root'
})
export class SessionGuard  {
    private readonly sessionManager = inject(SessionManager);
    private readonly router = inject(Router);


    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

        const routeData = next.data as RouteData;
        const nextViewName = this.sessionManager.getViewNameFromRoute(state.url);
        const nextSession = this.sessionManager.getSession(nextViewName);
        const returnToRoute = this.sessionManager.getRouteFromViewName(routeData.returnTo);
        const defaultPageRoute = this.sessionManager.getRouteFromViewName(ViewName.CREATE_PARTY);

        if (!nextSession) {
            this.router.navigateByUrl(defaultPageRoute);

            return false;
        }

        routeData.check.forEach((key: ViewName) => {

            const sessionData = nextSession[key];

            if (!sessionData || !Object.keys(sessionData).length) {
                this.router.navigateByUrl(returnToRoute || defaultPageRoute);

                return false;
            }

        });

        return true;

    }

}
